/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Parallel edge tangent w.r.t. another edge</h4>

<p>Make an edge's tangent parallel to the tangent of another edge.</p>
<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('703231640')}" loading="lazy"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'>No shortcuts for this operation</li>
</ul>`;

export default function EdgeToEdgeParallelTooltip() {
    return h('div', { innerHTML: body });
}
